import { useAtom } from "jotai/react";

import { LANGUAGES } from "@/constants/language";
import { languageAtom } from "@/store/language";

export const useLanguageDirection = () => {
	const [lang] = useAtom(languageAtom);

	return LANGUAGES[lang]?.mode ?? "ltr";
};
